import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ngx-cm-counter',
  templateUrl: './ngx-cm-counter.component.html',
  styleUrls: ['./ngx-cm-counter.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgxCmCounterComponent),
    multi: true
  }]
})
export class NgxCmCounterComponent implements ControlValueAccessor, OnInit {
  @Input()
  Min = 0;

  contextValue: any = 0;
  onChange;

  constructor() { }

  ngOnInit() {
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) { }

  writeValue(value) {
    this.contextValue = value ? value : this.Min;
  }

  updateValue(value) {
    this.contextValue = value;
    if (this.onChange) {
      this.onChange(value);
    }
  }

  increment() {
    this.updateValue(++this.contextValue);
  }

  decrement() {
    if (this.contextValue > this.Min) {
      this.updateValue(--this.contextValue);
    }
  }

  keyDown(event) {
    let code = event.keyCode;
    let isCtrl = event.ctrlKey;

    if (code == 8 || code == 9) {
      return;
    }
    if (code == 65 && isCtrl) {
      return;
    }
    // 96 - 105 & 48 - 57
    if (!((code <= 57 && code >= 48) || (code <= 105 && code >= 96))) {
      event.preventDefault();
    }
  }
}
